import { Header, type NavItemInterface } from '../../base/Header'
import { Footer } from '../../base/Footer'
import { paths } from '@/configs/paths'
import { format } from 'date-fns'
import { STATUS_INBOUND, STATUS_OUTBOUND } from '@/constants/mroEnum'
import { getFirstDayOfCurrentMonth, getLastDayOfCurrentMonth } from '@/utils/dateTime'

import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

const DistributorAdminLayout = ({ children }) => {
  const { t } = useTranslation()

  const navItems: NavItemInterface[] = useMemo(
    () => [
      {
        label: t('SGV' as any),
        href: paths.inStock.path,
        activeMatchers: [paths.inStock.path, paths.inTransit.path]
      },
      {
        label: t('Inventory' as any),
        subItems: [
          {
            label: t('Inbound' as any),
            href: paths.inboundList.getHref(STATUS_INBOUND.WAITING.value)
          },
          {
            label: t('Outbound' as any),
            href: paths.outboundList.getHref(STATUS_OUTBOUND.NOT_RECEIVED.value)
          },
          { label: t('Defect History' as any), href: paths.ngGoodsHistoryList.path }
        ]
      },
      {
        label: t('Order' as any),
        href: paths.ordersSalesBySupplier.getHref(format(new Date(), 'yyyy-MM')),
        activeMatchers: [
          paths.ordersSalesBySupplier.path,
          paths.ordersManagementList.path,
          paths.ordersMissingList.path
        ]
      },
      {
        label: t('Master' as any),
        subItems: [
          { label: t('Supplier' as any), href: paths.supplierMaster.path },
          { label: t('Customer' as any), href: paths.customerMaster.path },
          { label: t('Product' as any), href: paths.productMaster.path },
          { label: t('Stocker' as any), href: paths.stockMaster.path }
        ]
      },
      {
        label: t('Sales' as any),
        href: paths.salesBuy.getHref(
          undefined,
          getFirstDayOfCurrentMonth(),
          getLastDayOfCurrentMonth()
        ),
        activeMatchers: [paths.salesBuy.path, paths.salesReturn.path]
      }
    ],
    [t]
  )

  return (
    <div className='flex flex-col min-h-screen bg-[#F8FAFF]'>
      <Header navItems={navItems} />
      <main className='flex-1 p-3 py-2 xl:p-5 mt-14'>{children}</main>
      <Footer />
    </div>
  )
}

export default DistributorAdminLayout
